var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4766 23.1445C17.6898 23.1445 22.7266 18.1077 22.7266 11.8945C22.7266 5.68133 17.6898 0.644531 11.4766 0.644531C5.26336 0.644531 0.226562 5.68133 0.226562 11.8945C0.226562 18.1077 5.26336 23.1445 11.4766 23.1445ZM16.0708 10.3163C16.5799 9.85008 16.6146 9.05938 16.1484 8.55028C15.6821 8.04118 14.8914 8.00645 14.3823 8.47272L9.76721 12.6995L8.57082 11.6038C8.06171 11.1375 7.27102 11.1722 6.80475 11.6813C6.33848 12.1904 6.37321 12.9811 6.88231 13.4474L8.92296 15.3163C9.40074 15.7539 10.1337 15.7539 10.6115 15.3163L16.0708 10.3163Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.7208150a2e4b689eae0e081ffb9685b6.svg";
export { ForwardRef as ReactComponent };